import Consts from 'Framework/Consts';
import useAppDispatch from 'Shared/Store/dispatch/useAppDispatch';
import { useAppSelector } from 'Shared/Store/useAppSelector';
import { addMinutes } from 'Shared/Utils/Extensions/Date/DateExtensions';

import InsuranceModules from '../utils/InsuranceModules.Storage';

import { IInsuranceModule } from '../models/IInsuranceModule';
import InsuranceModuleSliceType from '../reducers/InsuranceModuleSliceType';
import { setInsuranceModules } from '../reducers/insuranceModuleSlice';
import getAllInsuranceModules from '../thunks/getAllInsuranceModules';

const useInsuranceModuleStorage = () => {
  const dispatch = useAppDispatch();
  const modulesStorage = InsuranceModules.getInstance();

  const { data } = useAppSelector<InsuranceModuleSliceType>((rootState: any) => rootState.common.insuranceModules);

  const fillInsuranceModulesState = () => {
    if (
      modulesStorage.modulesHasValue() &&
      !modulesStorage.modulesIsExpire() &&
      modulesStorage.getInsuranceModulesWithExpiry()?.length > 0
    ) {
      const modulesResult: IInsuranceModule[] = modulesStorage.getInsuranceModulesWithExpiry();
      if ((data?.length ?? 0) <= 0) {
        dispatch(setInsuranceModules(modulesResult));
      }
    } else {
      const token = localStorage.getItem('token');
      if (token) {
        dispatch(getAllInsuranceModules()).then((result: any) => {
          if (result.payload) {
            modulesStorage.setInsuranceModulesWithExpiry(
              result.payload,
              addMinutes(new Date(), Number(Consts.env.REACT_APP_LOCAL_STORAGE_INTERVAL ?? 60))
            );
          }
        });
      }
    }
  };

  return { fillInsuranceModulesState };
};

export default useInsuranceModuleStorage;
